import FaqList from '@/components/Faq/FaqList'
import FaqForm from '@/components/Faq/FaqForm'

let FaqRouter = [{
  path: '/faq',
  name: 'FaqList',
  component: FaqList,
  meta: {
    title: 'FAQ',
    requiresAuth: true,
    authorizations: ['faq_index', 'desktop_access']
  }
}, {
  path: '/faq/new',
  name: 'FaqNew',
  component: FaqForm,
  meta: {
    title: 'Nouvelle question',
    requiresAuth: true,
    authorizations: ['faq_new', 'desktop_access']
  }
}, {
  path: '/faq/:id/edit',
  name: 'FaqEdit',
  component: FaqForm,
  meta: {
    title: 'Modifier une question',
    requiresAuth: true,
    authorizations: ['faq_edit', 'desktop_access']
  }
}]

export default FaqRouter



// WEBPACK FOOTER //
// ./src/components/Faq/router.js